import { useEffect, useCallback, useMemo } from 'react';
import { QueryResult, FetchResult } from '@apollo/client';
import { useAuthToken } from './useAuthToken';
import { HeaMeQuery, HeaUser, useHeaMeLazyQuery, Exact, useFinishStudyPlanMutation, FinishStudyPlanMutation } from '@src/api/graphql-codegen';
import { isHomeEDApp } from '@constants';
import { logger } from '../utils/logger';

type UseUserResponse = [HeaUser | null | undefined, QueryResult<HeaMeQuery, Exact<{
  [key: string]: never;
}>>, (options?: any) => Promise<FetchResult<FinishStudyPlanMutation>>];
export const useHeaUser = (): UseUserResponse => {

  const [getHeaUser, heaquery] = useHeaMeLazyQuery({
    fetchPolicy: 'network-only',
  });
  const { hsaToken } = useAuthToken();
  const [finishStudyPlan, { data }] = useFinishStudyPlanMutation();
  const heaMe = useMemo(() => data?.finishStudyPlan || heaquery.data?.heaMe, [data?.finishStudyPlan, heaquery.data?.heaMe]);
  const fetchHeaUser = useCallback(async () => {
    try {
      await getHeaUser();
    } catch (e) {
      logger.info('fetching hea user error - ', e)
    }
  }, [getHeaUser])

  useEffect(() => {
    if (isHomeEDApp && hsaToken && !heaMe?.id) {
      setTimeout(() => {
        fetchHeaUser();
      }, 500);
    }
  }, [hsaToken, fetchHeaUser, heaMe?.id]);

  return [heaMe, heaquery, finishStudyPlan];
};
